import React from "react";

const SKILLS = [
  {
    category: "Frontend",
    tags: ["HTML5", "CSS3", "JavaScript (ES6+)", "TypeScript", "React", "Redux"],
  },
  {
    category: "Backend",
    tags: ["Node.js", "Express", "RESTful APIs", "MongoDB", "PostgreSQL"],
  },
  {
    category: "Tools & Workflow",
    tags: ["Git", "GitHub", "Vercel", "OAuth", "Agile / Scrum", "Bootstrap"],
  },
];

function Skills() {
  return (
    <div className="skills-section">
      <div className="skills-inner">
        <div className="section-header">
          <div className="section-label">What I work with</div>
          <h2 className="section-title light">Skills</h2>
        </div>

        <div className="skills-grid">
          {SKILLS.map(({ category, tags }) => (
            <div key={category} className="skill-card">
              <div className="skill-card-title">{category}</div>
              <div className="skill-tags">
                {tags.map((tag) => (
                  <span key={tag} className="skill-tag">{tag}</span>
                ))}
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

export default Skills;
